import React from "react";
import { useNavigate } from "react-router-dom";

export default function CourseCard({ course }) {
  const navigate = useNavigate();

  const handleViewMore = () => {
    navigate(`/online-course/${course.slug}`);
  };

  return (
    <div
      className="group relative h-full bg-white rounded-3xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.12)] border border-gray-100 transition-all duration-500 cursor-pointer flex flex-col hover:-translate-y-2"
      onClick={handleViewMore}
    >
      {/* Top Image Section */}
      <div className="relative h-[220px] overflow-hidden">
        {/* Format Badge */}
        <div className="absolute top-4 left-4 z-20 flex gap-2">
          {course.format === 'live' ? (
            <span className="px-3 py-1.5 rounded-full bg-[#0b0f19]/90 backdrop-blur-md text-white text-[10px] font-bold uppercase tracking-wider border border-white/10 flex items-center gap-1.5 shadow-lg">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></span>
              Live Cohort
            </span>
          ) : (
            <span className="px-3 py-1.5 rounded-full bg-white/90 backdrop-blur-md text-[#0b0f19] text-[10px] font-bold uppercase tracking-wider border border-gray-200 flex items-center gap-1.5 shadow-lg">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
              Self-Paced
            </span>
          )}
        </div>

        <img
          src={course.image}
          alt={course.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0f19]/80 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500"></div>
        
        {/* Difficulty Badge on Image */}
        <div className="absolute bottom-4 left-4 z-20">
           <span className="text-white font-medium text-xs bg-white/20 backdrop-blur-md px-3 py-1 rounded-md border border-white/20">
             {course.difficulty}
           </span>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-6 md:p-8 flex flex-col flex-grow relative bg-white">
        {/* Instructor Avatar (Mock) */}
        <div className="absolute -top-6 right-6 w-12 h-12 rounded-full border-4 border-white bg-gray-100 overflow-hidden shadow-sm z-30">
          <img src={`https://ui-avatars.com/api/?name=${(course.instructor || "Instructor").replace(/ /g, '+')}&background=random`} alt={course.instructor || "Instructor"} className="w-full h-full object-cover" />
        </div>

        <div className="flex items-center gap-3 mb-4 text-[11px] font-bold uppercase tracking-wider text-gray-400">
          <span className="flex items-center gap-1">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3.5 h-3.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            {course.duration}
          </span>
          <span className="w-1 h-1 rounded-full bg-gray-300"></span>
          <span>{course.instructor || "E1X Academy"}</span>
        </div>

        <h3 className="font-bold text-2xl text-[#0b0f19] mb-3 leading-tight group-hover:text-primary transition-colors line-clamp-2">
          {course.title}
        </h3>
        
        <p className="text-gray-500 text-sm leading-relaxed mb-6 line-clamp-3 flex-grow">
          {course.desc}
        </p>

        {/* Footer Area */}
        <div className="pt-6 mt-auto border-t border-gray-100 flex items-center justify-between">
          <span className="font-bold text-sm text-[#0b0f19] group-hover:text-primary transition-colors">Learn more</span>

          <button className="w-10 h-10 rounded-full bg-gray-50 border border-gray-200 flex items-center justify-center text-gray-600 group-hover:bg-primary group-hover:border-primary group-hover:text-white transition-all duration-300 transform group-hover:translate-x-1">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
          </button>
        </div>
      </div>
    </div>
  );
}
